import { Component } from '@angular/core';
import { AppConfig } from '../../../config/appConfig';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent {
  title = AppConfig.title;

}
